import styled from "styled-components";

export const TrainProgressContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px 0;
`;

export const ContentArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const UploadStatusContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const NoDataWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding: 60px 20px;
`;

export const NoDataTitle = styled.h3`
  font-size: 24px;
  font-weight: 600;
  color: ${(props) => props.theme.colors.text};
  margin: 0;
`;

export const NoDataDescription = styled.p`
  font-size: 16px;
  color: ${(props) => props.theme.colors.textSecondary};
  margin: 0;
  text-align: center;
`;

